export enum PaymentMethod {
  cash = 'CASH',
  creditCard = 'CREDIT_CARD',
  check = 'CHECK',
  enligne = 'EN_LIGNE',
  transfer = 'TRANSFER',
  unpaid = 'UNPAID',
}

export type DateFilterMode =
  | 'All'
  | 'Range'
  | 'Today'
  | 'Yesterday'
  | 'Last 7 Days'
  | 'Last 30 Days';

export interface ColumnFilter {
  id: string;
  value: unknown;
}

export type ColumnFiltersState = ColumnFilter[];

export type Filters = {
  page: number;
  pagesize: number;
  sortBy: string;
  sortOrder: string;
  date_from?: string;
  date_to?: string;
  appointment_payment_method?: PaymentMethod;
  usernameId?: string;
  transaction_group_id_exclusive?: string;
  search?: string;
  columnFilters: ColumnFiltersState;
};

export interface FiltersState {
  filters: Filters;
  currentTab: string;
  dateFilterMode: DateFilterMode;
}
